<template>
  <div>
    <b-card-text>
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ $t('pages.settings.store_settings.title') }}</h4>
          <p class="card-title-desc">{{ $t('pages.settings.store_settings.subtitle') }}</p>
          <div class="p-3">
            <form>
              <b-form-group
                  class="mb-3"
                  :label="$t('pages.settings.store_settings.business_name') "
                  label-for="businessName"
              >
                <b-form-input
                    id="businessName"
                    v-model="businessName"
                    :placeholder="$t('pages.settings.store_settings.business_name_placeholder') "
                    :class="{'is-invalid': (submitted && $v.businessName.$error)}"
                />
                <div
                    v-if="submitted && !$v.businessName.required"
                    class="invalid-feedback"
                >
                  {{ $t('pages.settings.store_settings.validations.business_name_required') }}
                </div>
                <div
                    v-if="submitted && !$v.businessName.minLength"
                    class="invalid-feedback"
                >
                  {{
                    $t('pages.settings.store_settings.validations.business_name_min', {min: $v.businessName.$params.minLength.min})
                  }}
                </div>
                <div
                    v-if="submitted && !$v.businessName.maxLength"
                    class="invalid-feedback"
                >
                  {{
                    $t('pages.settings.store_settings.validations.business_name_max', {max: $v.businessName.$params.maxLength.max})
                  }}
                </div>
              </b-form-group>
            </form>
            <div class="row mt-5">
              <h4 class="card-title">{{ $t('pages.settings.store_settings.alerts') }}</h4>
              <p class="card-title-desc">{{ $t('pages.settings.store_settings.alert_desc') }}</p>
              <div class="col-sm-6">
                <b-form-group
                    v-if="false"
                    class="mb-3"
                    :label="$t('pages.settings.store_settings.receive_email') "
                >
                  <b-form-select
                      class="form-select"
                      v-model="timing"
                      :options="timingOptions"
                  />
                </b-form-group>
              </div>
              <div class="col-sm-6" v-if="timing">
                <b-form-group
                    class="mb-3"
                    :label="$t('pages.settings.store_settings.posting_time')"
                >
                  <b-form-input
                      id="time"
                      v-model="time"
                      value="13:45:00"
                      type="time"
                  />
                </b-form-group>
              </div>
              <div class="mt-2">
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="negativeSellerFeedback"
                      v-model="feedbackNotifications.negative"
                  />
                  <label
                      class="form-check-label"
                      for="negativeSellerFeedback">
                    {{ $t('pages.settings.store_settings.negative_seller_feedback') }}
                  </label>
                </div>
                <div class="form-check form-switch form-switch-md mb-3" v-if="false">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="positiveSellerFeedback"
                      checked=""
                      v-model="feedbackNotifications.positive"
                  />
                  <label class="form-check-label"
                         for="positiveSellerFeedback">
                    {{ $t('pages.settings.store_settings.positive_seller_feedback') }}
                  </label>
                </div>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="negativeProductReview"
                      v-model="reviewNotifications.negative"
                  />
                  <label class="form-check-label"
                         for="negativeProductReview">
                    {{ $t('pages.settings.store_settings.negative_product_review') }}
                  </label>
                </div>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="positiveProductReview"
                      v-model="reviewNotifications.positive"
                  />
                  <label class="form-check-label"
                         for="positiveProductReview">
                    {{ $t('pages.settings.store_settings.positive_product_review') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <b-col cols="12" align="end">
                <b-btn variant="success" @click="update">
                  <i class="mdi mdi-content-save" style="margin-right: 6px;" v-if="!loading"></i>
                  <b-spinner v-else small></b-spinner>
                  {{ $t('pages.settings.store_settings.update_btn') }}
                </b-btn>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </b-card-text>
  </div>
</template>

<script>
import SettingService from "../../../Services/Api/SettingService";
import {maxLength, minLength, required} from "vuelidate/lib/validators";

export default {
  name: "StoreSettings",
  data() {
    return {
      timing: false,
      businessName: '',
      time: null,
      feedbackNotifications: {
        negative: false,
        positive: false
      },
      reviewNotifications: {
        negative: false,
        positive: false
      },
      timingOptions: [
        {
          text: this.$t('pages.settings.store_settings.title'),
          value: false
        },
        {
          text: this.$t('pages.settings.store_settings.certain_time'),
          value: true
        }
      ],
      loading: false,
      submitted: false
    }
  },
  validations: {
    businessName: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(180)
    }
  },
  methods: {
    async update() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return
      } else {
        this.loading = true
        const payload = {
          time: this.timing ? this.time : null,
          business_name: this.businessName,
          negative_seller_feedback: this.feedbackNotifications.negative,
          positive_seller_feedback: this.feedbackNotifications.positive,
          negative_product_review: this.reviewNotifications.negative,
          positive_product_review: this.reviewNotifications.positive
        }

        await SettingService.updateSetting({payload}).then(() => {
        }).finally(() => {
          this.loading = false
        })
      }
    },
    async getSetting() {
      const {data: setting} = await SettingService.getSetting()

      if (setting.data.time) {
        this.timing = true
        this.time = setting.data.time
      }

      this.businessName = setting.data.business_name
      this.feedbackNotifications.negative = setting.data.negative_seller_feedback
      this.feedbackNotifications.positive = setting.data.positive_seller_feedback
      this.reviewNotifications.negative = setting.data.negative_product_review
      this.reviewNotifications.positive = setting.data.positive_product_review
    }
  },
  created() {
    this.getSetting()
  }
}
</script>

<style scoped>

</style>